import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="search-form"
export default class extends Controller {
  static targets = ["clear", "q"];
  connect() {
    addEventListener("turbo:load", (event) => {
      this.element.action = document.location.pathname;
      if (this.hasClearTarget) {
        this.clearTarget.href = document.location.pathname;
      }
      if (!document.location.search.match("q=")) {
        this.qTarget.value = "";
      }
    });
  }
}
